/* src/components/ZoomControl/ZoomControl.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	subscribe,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { clamp } from "../helpers";
import Icon from "../Icon";
import Icons from "../Icons";
import Button from "../Button";

function create_default_slot_5(ctx) {
	let icons_plus;
	let current;
	icons_plus = new Icons.Plus({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_plus.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_plus, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_plus_changes = {};
			if (dirty & /*theme*/ 1) icons_plus_changes.theme = /*theme*/ ctx[0];
			icons_plus.$set(icons_plus_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_plus.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_plus.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_plus, detaching);
		}
	};
}

// (82:2) <Button class="plus" {name} {theme} disabled={plus_disabled} on:click={plus} content={t.plus}>
function create_default_slot_4(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.plus[/*type*/ ctx[5]],
				alt: "[plus]",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 34) icon_changes.src = /*icons*/ ctx[1]?.plus[/*type*/ ctx[5]];

			if (dirty & /*$$scope, theme*/ 131073) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (90:4) {:else}
function create_else_block(ctx) {
	let t0_value = Math.ceil(/*scale*/ ctx[2] * 100) + "";
	let t0;
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text("%");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*scale*/ 4 && t0_value !== (t0_value = Math.ceil(/*scale*/ ctx[2] * 100) + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (88:4) {#if $camera == null}
function create_if_block(ctx) {
	let t_1;

	return {
		c() {
			t_1 = text("…");
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (95:4) <Icon src={icons?.minus[type]} alt="[minus]">
function create_default_slot_3(ctx) {
	let icons_minus;
	let current;
	icons_minus = new Icons.Minus({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_minus.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_minus, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_minus_changes = {};
			if (dirty & /*theme*/ 1) icons_minus_changes.theme = /*theme*/ ctx[0];
			icons_minus.$set(icons_minus_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_minus.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_minus.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_minus, detaching);
		}
	};
}

// (94:2) <Button class="minus" {name} {theme} disabled={minus_disabled} on:click={minus} content={t.minus}>
function create_default_slot_2(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.minus[/*type*/ ctx[5]],
				alt: "[minus]",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 34) icon_changes.src = /*icons*/ ctx[1]?.minus[/*type*/ ctx[5]];

			if (dirty & /*$$scope, theme*/ 131073) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (100:4) <Icon src={icons?.reset[type]} alt="[reset]">
function create_default_slot_1(ctx) {
	let icons_reset;
	let current;
	icons_reset = new Icons.Reset({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_reset.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_reset, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_reset_changes = {};
			if (dirty & /*theme*/ 1) icons_reset_changes.theme = /*theme*/ ctx[0];
			icons_reset.$set(icons_reset_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_reset.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_reset.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_reset, detaching);
		}
	};
}

// (99:2) <Button class="reset" {name} {theme} {disabled} on:click={reset} content={t.reset}>
function create_default_slot(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.reset[/*type*/ ctx[5]],
				alt: "[reset]",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 34) icon_changes.src = /*icons*/ ctx[1]?.reset[/*type*/ ctx[5]];

			if (dirty & /*$$scope, theme*/ 131073) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let button0;
	let t0;
	let span;
	let span_class_value;
	let t1;
	let button1;
	let t2;
	let button2;
	let div_class_value;
	let current;

	button0 = new Button({
			props: {
				class: "plus",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*plus_disabled*/ ctx[7],
				content: /*t*/ ctx[9].plus,
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*plus*/ ctx[11]);

	function select_block_type(ctx, dirty) {
		if (/*$camera*/ ctx[4] == null) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	button1 = new Button({
			props: {
				class: "minus",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*minus_disabled*/ ctx[6],
				content: /*t*/ ctx[9].minus,
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*minus*/ ctx[12]);

	button2 = new Button({
			props: {
				class: "reset",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*disabled*/ ctx[3],
				content: /*t*/ ctx[9].reset,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button2.$on("click", /*reset*/ ctx[13]);

	return {
		c() {
			div = element("div");
			create_component(button0.$$.fragment);
			t0 = space();
			span = element("span");
			if_block.c();
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			create_component(button2.$$.fragment);
			attr(span, "class", span_class_value = "" + (name + "-text " + /*theme*/ ctx[0]));
			attr(div, "class", div_class_value = "" + (name + " " + /*theme*/ ctx[0]));
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(button0, div, null);
			append(div, t0);
			append(div, span);
			if_block.m(span, null);
			append(div, t1);
			mount_component(button1, div, null);
			append(div, t2);
			mount_component(button2, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const button0_changes = {};
			if (dirty & /*theme*/ 1) button0_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*plus_disabled*/ 128) button0_changes.disabled = /*plus_disabled*/ ctx[7];
			if (dirty & /*t*/ 512) button0_changes.content = /*t*/ ctx[9].plus;

			if (dirty & /*$$scope, icons, type, theme*/ 131107) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(span, null);
				}
			}

			if (!current || dirty & /*theme*/ 1 && span_class_value !== (span_class_value = "" + (name + "-text " + /*theme*/ ctx[0]))) {
				attr(span, "class", span_class_value);
			}

			const button1_changes = {};
			if (dirty & /*theme*/ 1) button1_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*minus_disabled*/ 64) button1_changes.disabled = /*minus_disabled*/ ctx[6];
			if (dirty & /*t*/ 512) button1_changes.content = /*t*/ ctx[9].minus;

			if (dirty & /*$$scope, icons, type, theme*/ 131107) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);
			const button2_changes = {};
			if (dirty & /*theme*/ 1) button2_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*disabled*/ 8) button2_changes.disabled = /*disabled*/ ctx[3];
			if (dirty & /*t*/ 512) button2_changes.content = /*t*/ ctx[9].reset;

			if (dirty & /*$$scope, icons, type, theme*/ 131107) {
				button2_changes.$$scope = { dirty, ctx };
			}

			button2.$set(button2_changes);

			if (!current || dirty & /*theme*/ 1 && div_class_value !== (div_class_value = "" + (name + " " + /*theme*/ ctx[0]))) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(button2.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(button2.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(button0);
			if_block.d();
			destroy_component(button1);
			destroy_component(button2);
		}
	};
}

const i18n = {
	en: {
		plus: "Zoom In",
		minus: "Zoom Out",
		reset: "Reset"
	},
	"zh-CN": {
		plus: "\u653E\u5927",
		minus: "\u7F29\u5C0F",
		reset: "\u91CD\u7F6E"
	}
};

const scales = [
	0.3,
	0.4096000000000002,
	0.5120000000000001,
	0.6400000000000001,
	0.8,
	1,
	1.26,
	1.5876000000000001,
	2.000376,
	2.5204737600000002,
	3
];

function next_scale(scale, delta) {
	const { length } = scales;
	const last = length - 1;
	if (scale < scales[0]) return scales[0];
	if (scale > scales[last]) return scales[last];

	for (let i = 0; i < length; ++i) {
		const cur = scales[i];
		const prev = i === 0 ? -Infinity : (scales[i - 1] + cur) / 2;
		const next = i === last ? Infinity : (scales[i + 1] + cur) / 2;
		if (prev <= scale && scale <= next) return scales[clamp(i + delta, 0, last)];
	}

	return 1;
}

const name = "fastboard-zoom-control";

function instance($$self, $$props, $$invalidate) {
	let writable;
	let disabled;
	let t;
	let camera;
	let scale;
	let plus_disabled;
	let minus_disabled;

	let $camera,
		$$unsubscribe_camera = noop,
		$$subscribe_camera = () => ($$unsubscribe_camera(), $$unsubscribe_camera = subscribe(camera, $$value => $$invalidate(4, $camera = $$value)), camera);

	let $writable,
		$$unsubscribe_writable = noop,
		$$subscribe_writable = () => ($$unsubscribe_writable(), $$unsubscribe_writable = subscribe(writable, $$value => $$invalidate(16, $writable = $$value)), writable);

	$$self.$$.on_destroy.push(() => $$unsubscribe_camera());
	$$self.$$.on_destroy.push(() => $$unsubscribe_writable());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { icons = void 0 } = $$props;
	let type;

	function plus() {
		app?.moveCamera({
			scale: next_scale(scale, 1),
			centerX: 0,
			centerY: 0
		});
	}

	function minus() {
		app?.moveCamera({
			scale: next_scale(scale, -1),
			centerX: 0,
			centerY: 0
		});
	}

	function reset() {
		app?.moveCamera({ scale: 1, centerX: 0, centerY: 0 });
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(14, app = $$props.app);
		if ('theme' in $$props) $$invalidate(0, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(15, language = $$props.language);
		if ('icons' in $$props) $$invalidate(1, icons = $$props.icons);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 16384) {
			$: $$subscribe_writable($$invalidate(10, writable = app?.writable));
		}

		if ($$self.$$.dirty & /*$writable*/ 65536) {
			$: $$invalidate(3, disabled = !$writable);
		}

		if ($$self.$$.dirty & /*language*/ 32768) {
			$: $$invalidate(9, t = i18n[language]);
		}

		if ($$self.$$.dirty & /*disabled*/ 8) {
			$: $$invalidate(5, type = disabled ? "disable" : "normal");
		}

		if ($$self.$$.dirty & /*app*/ 16384) {
			$: $$subscribe_camera($$invalidate(8, camera = app?.camera));
		}

		if ($$self.$$.dirty & /*$camera*/ 16) {
			$: $$invalidate(2, scale = $camera?.scale ?? 1);
		}

		if ($$self.$$.dirty & /*disabled, scale*/ 12) {
			$: $$invalidate(7, plus_disabled = disabled || next_scale(scale, 1) === scale);
		}

		if ($$self.$$.dirty & /*disabled, scale*/ 12) {
			$: $$invalidate(6, minus_disabled = disabled || next_scale(scale, -1) === scale);
		}
	};

	return [
		theme,
		icons,
		scale,
		disabled,
		$camera,
		type,
		minus_disabled,
		plus_disabled,
		camera,
		t,
		writable,
		plus,
		minus,
		reset,
		app,
		language,
		$writable
	];
}

class ZoomControl extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			app: 14,
			theme: 0,
			language: 15,
			icons: 1
		});
	}
}

export default ZoomControl;